import React, { Component } from 'react';
import { TextBox } from 'devextreme-react';
import i18n from '../../../i18n';
import PropTypes from 'prop-types';

class ReadOnlyTextBox extends Component {
    render() {
        const { value, i18nLabel } = this.props;

        return (
            <div className={'dx-field'}>
                <div className={'dx-field-label'}>
                    {i18n.t(i18nLabel) + ':'}
                </div>

                <div className={'dx-field-value'}>
                    <TextBox
                        className={'multi-language'}
                        name={'name'}
                        value={value ? (typeof value === 'string' ? value : value.toString()) : ''}
                        readOnly={true}
                    />
                </div>
            </div>
        );
    }
}

ReadOnlyTextBox.propTypes = {
    i18nLabel: PropTypes.any,
    value: PropTypes.any
};

export default ReadOnlyTextBox;
